const pageHeaderType = 'PAGE_HEADER';
const pageheaderMegaMenuType = 'PAGE_HEADER_MEGA_MENU';
const pageHeaderLanguageBarType = 'PAGE_HEADER_LANGUGE_BAR';

const pageTopMenuType = 'PAGE_TOP_MENU';
const pageTwoSidebarType = 'PAGE_TWO_SIDEBAR';
const pageRightSidebarType = 'PAGE_RIGHT_SIDEBAR';
const pageRightSidebarToggledType = 'PAGE_RIGHT_SIDEBAR_TOGGLED';
const pageMobileRightSidebarToggledType = 'PAGE_MOBILE_RIGHT_SIDEBAR_TOGGLED';

const initialState = {
    pageHeader: true,
    pageheaderMegaMenu: false,
    pageHeaderLanguageBar: false,

    pageTopMenu: false,
    pageTwoSidebar: false,
    pageRightSidebar: false,
    pageRightSidebarToggled: true,
    pageMobileRightSidebarToggled: false,
};

export const headerActions = {
    handleSetPageHeader: () => ({ type: pageHeaderType }),
    handleSetPageHeaderMegaMenu: () => ({ type: pageheaderMegaMenuType }),
    handleSetPageHeaderLanguageBar: () => ({ type: pageHeaderLanguageBarType }),

    handleSetPageTwoSidebar: () => ({ type: pageTopMenuType }),
    handleSetPageTopMenu: () => ({ type: pageTwoSidebarType }),
    toggleRightSidebar: () => ({ type: pageRightSidebarType }),
    toggleMobileRightSidebar: () => ({ type: pageRightSidebarToggledType }),
    handleSetPageRightSidebar: () => ({ type: pageMobileRightSidebarToggledType }),
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case pageHeaderType:
            return { ...state, pageHeader: !state.pageHeader };

        case pageheaderMegaMenuType:
            return { ...state, pageheaderMegaMenu: !state.pageheaderMegaMenu };

        case pageHeaderLanguageBarType:
            return { ...state, pageHeaderLanguageBar: !state.pageHeaderLanguageBar };


        case pageTopMenuType:
            return { ...state, pageTopMenu: !state.pageTopMenu };

        case pageTwoSidebarType:
            return { ...state, pageTwoSidebar: !state.pageTwoSidebar };

        case pageRightSidebarType:
            return { ...state, pageRightSidebar: !state.pageRightSidebar };

        case pageRightSidebarToggledType:
            return { ...state, pageRightSidebarToggled: !state.pageRightSidebarToggled };

        case pageMobileRightSidebarToggledType:
            return { ...state, pageMobileRightSidebarToggled: !state.pageMobileRightSidebarToggled };


        default: 
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/admin/header.js